import { render, staticRenderFns } from "./SunOutline.vue?vue&type=template&id=298fac86&"
import script from "./SunOutline.vue?vue&type=script&lang=ts&"
export * from "./SunOutline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports